import React, { useState } from 'react';
import { EntityWithLabel } from '../../../api/ApiTypes';
import { DropButton } from '../../../ui/DropButton';
import { Tip } from '../../../ui/Tip';
import { Popover } from '../../canvas/ui/Popover';
import { Copy } from '../../dashboard/elements/LayoutElements';
import { WorkspaceInfoView } from './WorkspaceInfoView';

// export type WorkspaceInfoTableButtonProps = TableButtonProps & {
//     value?: EntityWithLabel,
//     children?: React.ReactNode,
// };

// export const WorkspaceInfoTableButton = ({ disabled, variant, value }: WorkspaceInfoTableButtonProps) => {

//     const [open, setOpen] = useState(false);

//     return <Popover
//         placement="top"
//         content={<AutoLoadWorkspaceInfoCardView workspaceId={value.id} />}
//         inner={{ direction: 'up' }}
//         open={open}
//         onOpenChange={setOpen}
//         disabled={disabled}
//     >
//         <TableButton active={open} variant={variant}>
//             {value?.label}
//         </TableButton>
//     </Popover>;
// };

export type WorkspaceInfoButtonProps = {
    workspace: EntityWithLabel,
    children?: React.ReactNode,
};

export const WorkspaceInfoButton = ({ workspace }: WorkspaceInfoButtonProps) => {

    const [open, setOpen] = useState(false);

    return <Tip text={workspace?.id} disabled={open}>
        <Popover
            content={<WorkspaceInfoView workspaceId={workspace.id} />}
            placement="bottom-start"
            inner={{ direction: 'down' }}
            open={open}
            onOpenChange={setOpen}
        >
            <DropButton active={open} overflow="0 -.5 0 -.5" padding=".25 0 .25 0" onClick={() => setOpen(true)}>
                <Copy flush>{workspace?.label}</Copy>
            </DropButton>
        </Popover>
    </Tip>;
};

